var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.1615 30.6665C24.8262 34.0018 16.2847 30.8679 9.08349 23.6667C1.88227 16.4655 -1.25167 7.92393 2.08362 4.58862L4.27966 2.39258C5.7957 0.876532 8.29378 0.916607 9.85926 2.48209L13.2607 5.88356C14.8262 7.44904 14.8663 9.94711 13.3502 11.4632L12.8786 11.9348C12.06 12.7534 11.9799 14.0738 12.7405 14.9955C13.4741 15.8845 14.265 16.77 15.1226 17.6276C15.9801 18.4851 16.8656 19.276 17.7546 20.0096C18.6763 20.7702 19.9968 20.6901 20.8153 19.8716L21.287 19.3999C22.803 17.8839 25.3011 17.9239 26.8666 19.4894L30.2681 22.8909C31.8335 24.4564 31.8736 26.9545 30.3576 28.4705L28.1615 30.6665Z",
    fill: "#0036DD",
    stroke: "#0036DD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7116 11.5202C25.2952 10.5045 24.6746 9.55281 23.8498 8.72805C23.0716 7.94985 22.1805 7.35344 21.2291 6.9388",
    stroke: "#0036DD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2291 1.13222C23.5069 1.95738 25.644 3.28299 27.47 5.10907C29.3419 6.98098 30.6879 9.1797 31.5081 11.5217",
    stroke: "#0036DD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/Calling.d13c6f17cf60ec4530e7d3ee64a70442.svg";
export { ForwardRef as ReactComponent };